export const MODULE_NAME = 'customer';
export const ACCESS_NAME = 'Customers';
